/**
 * Handle first-run modal submissions.
 */
import { normalizeHomeZipPostal } from '../../modules/utils';
import { ensureSettings, saveSettings as saveSettingsToStorage } from '../../modules/state';
import { closeFirstRunModal } from '../../modules/ui';
import type { SettingsHandlerDeps } from './types';

export async function handleFirstRunSubmit(deps: SettingsHandlerDeps): Promise<void> {
  const { els, state, render, upsertUserProfile, cfg } = deps;

  const company = els.firstRunCompany?.value.trim() || '';
  const timeZone = els.firstRunTimeZone?.value || '';
  const zipRaw = els.firstRunZip?.value.trim() || '';
  const homePostalCode = normalizeHomeZipPostal(zipRaw);

  const settings = ensureSettings();
  let changed = false;

  if (company && company.length > 0) {
    changed = true;
  }
  if (timeZone && timeZone.length > 0 && settings.timeZone !== timeZone) {
    settings.timeZone = timeZone;
    changed = true;
  }
  if (homePostalCode && homePostalCode !== settings.zipCode) {
    settings.zipCode = homePostalCode;
    if (els.settingsZip) {
      els.settingsZip.value = homePostalCode;
    }
    changed = true;
  }

  if (changed) {
    saveSettingsToStorage();
    if (state.mode === 'auth0' && company) {
      try {
        await upsertUserProfile(cfg, { company });
      } catch {
        // Silently fail
      }
    }
  }

  closeFirstRunModal();

  const windowWithCache = window as Window & {
    __distanceCache?: Record<string, unknown>;
    __distanceCalculationsStarted?: Set<unknown>;
  };
  windowWithCache.__distanceCache = {};
  if (typeof windowWithCache.__distanceCalculationsStarted !== 'undefined') {
    windowWithCache.__distanceCalculationsStarted.clear();
  }

  render();
}
